document.addEventListener('DOMContentLoaded', function () {

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);

      var day = result.getDay();

      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit'
    }).format(date);
  }

  var minElement = document.getElementById('tp24-delivery-min');
  var maxElement = document.getElementById('tp24-delivery-max');

  if (!minElement || !maxElement) return;

  var today = new Date();

  // 2–8 Werktage
  var earliestDelivery = addBusinessDays(today, 2);
  var latestDelivery = addBusinessDays(today, 8);

  minElement.textContent = formatDate(earliestDelivery);
  maxElement.textContent = formatDate(latestDelivery);

});